export const abcPurchaseReport = {
	title: "Informe ABC de Compras",
	label: "ABC de Compras",
	description:
		"El método de la curva ABC en la gestión del inventario revelará principalmente la importancia de cada elemento para la empresa - es decir, cuáles son las mercancías más caras que necesitan atención en el control y negocios del costo durante el proceso de compras.",
	export: "Descargar en Excel",
	filterByPlaceholder: "Todas las curvas",
	contentTable: {
		emptyReports: "No hay informes disponibles",
		totalizers: {
			totalValues: "Valores totales de los productos",
			curveA: "Curva A",
			curveB: "Curva B",
			curveC: "Curva C",
			tooltips: {
				curveA:
					"Productos con alto valor que corresponden hasta el 80% del valor de las compras",
				curveB:
					"Productos con valor intermedio que corresponden hasta el 15% del valor de las compras",
				curveC:
					"Productos con bajo valor que corresponden hasta el 5% del valor de las compras",
			},
		},
		columns: {
			name: "Producto o Insumo",
			quantity: "Cant. Comprada",
			unitaryValue: "Costo Unitario",
			total: "Costo Total",
			cumulateTotal: "Total Acumulado",
			percentage: "Representación Individual",
			cumulativePercentage: "Representación Acumulada",
			tier: "Clasificación",
		},
	},
};
